import { oauthProviderClient } from '@better-auth/oauth-provider/client';
import { passkeyClient } from '@better-auth/passkey/client';
import { emailOTPClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: globalThis.location === undefined ? process.env.NEXT_PUBLIC_BASE_URL : globalThis.location.origin,
  plugins: [emailOTPClient(), passkeyClient(), oauthProviderClient()],
});

export const { signIn, signOut, useSession } = authClient;

interface AuthNetworkError {
  cause: unknown;
  code?: undefined;
  status?: undefined;
}

/**
 * Resolves a network failure, which auth client calls reject with, into `error` like an HTTP error.
 */
export const settleAuthRequest = async <T extends { error: unknown }>(
  request: Promise<T>
): Promise<T | { data: undefined; error: AuthNetworkError }> => {
  try {
    return await request;
  } catch (error) {
    return { data: undefined, error: { cause: error } };
  }
};
